import { apiRequest } from '@/api/utils';

export default {
  getUser: () => apiRequest.get('get-user'),

  login: ({ username, password }) => apiRequest.post('login', { username, password }),

  logout: () => apiRequest.post('logout'),
};
